<span *ngIf="!tooltipEnabled" class="bx--col-1" style="border-radius: 2px; padding: 4px 8px 4px 8px;" [ngStyle]="{'background-color': bgColor}">
  <span [ngStyle]="{'color': textColor}" style="font-weight: 600; font-size: 13px; line-height: 15px;" [innerHTML]="tagTitle"></span>
</span>

<span *ngIf="tooltipEnabled" class="kaizen-tooltip">
  <span style="border-radius: 2px; padding: 4px 8px 4px 8px;"
        [ngStyle]="{'background-color': bgColor}">
    <span [id]="'tagsContent_' + tagTitle" [ngStyle]="{'color': textColor}" style="font-weight: 600; font-size: 13px; line-height: 15px;" [innerHTML]="tagTitle">
    </span>
    <span style="font-size: 13px; font-family: 'Work Sans', sans-serif" class="kaizen-tooltip-content"
          [ngClass]="'tooltip-' + 'top' + '-' + 'center'">
      <span>{{tooltipContent}}</span>
      <i class="caret" [ngClass]="'caret-' + 'center'"></i>
    </span>

  </span>
</span>
